import React from "react";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import AppealButton from "../AppealButton"
import { SystemIcons } from "../../common/SystemIcons";
import moment from "moment";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import AssessmentDetailTab from "./AssessmentDetailTab";
import Swal from "sweetalert2";
import { BASE_URL, UPLOAD_ROOT_PATH } from "../../../utils/Constants";
import { setAssessmentReview } from "../../../store/actions";
import { download } from "../../../utils/FileDownload";

const ShowResult = ({ data }) => (
  data.assessmentMarkPercentage == 0 ?
    (<div className='ass-status status-dark-red'><i className="fas fa-circle red"></i>Incomplete</div>) :
    data.assessmentMarkPercentage > 49 ?
      (<div className='ass-status status-green'><i className="fas fa-circle green"></i>Competent</div>) :
      (<div className='ass-status status-dark-red'><i className="fas fa-circle yellow" ></i>Not Yet Competent</div>)
);

const ShowResultPercent = ({ data }) => (
    data.assessmentMarkPercentage == 0 ?
      (data.status == "Closed-Submitted" ? 'Pending' : 'Incomplete') :
      data.assessmentMarkPercentage > 49 ?
        'Competent' :
        'Not Yet Competent'
)


const Step7 = (props) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();

  const handleDownload = ()=>{
    const absolutePath = props?.data.assFile.includes("https") ? props?.data.assFile : BASE_URL + "/" + props?.data.assFile.replaceAll(`${UPLOAD_ROOT_PATH}/`, "").replace("public/","").replace("null/","");
    const fileName =  props?.data.assFileName;
    const path_size = props?.data.path_size ? props?.data.path_size : null;

    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to download the assessment files?",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'I am sure',
      html: `Do you want to download assessment files? <br/><br/><b>File Size: ${path_size}</b>`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await download(absolutePath, fileName);
      }
    })

  }


  return (
    <>
      <div class="tab-pane fade show active" id="Assessment-Detail">
        <div class="test-series-main-left-blk">
        <div class={`w-100 d-flex ${props.data.status !== 'Closed Not-Submitted' && props.data?.quiz_id ? 'flex-column justify-content-between align-items-start' : 'justify-content-between align-items-center'} mb-15`}>
        <div class="test-series-main-heading icon-add">
              <h4>{props.data && props.data.name ? props.data.name : ""}{props.data && props.data.code ? ` (${props.data.code})` : ""}</h4>
              <span class="test-series-main-left-heading-act">
                <SystemIcons data={props.data} />
              </span>
            </div>
            <div class={`btn-action-block ${props.data.status !== 'Closed Not-Submitted' && props.data?.quiz_id ? 'w-100 pt-2' : ''} d-flex justify-content-between`}>
            <div>
                {(props.data.quiz_id == 0 && props?.data?.is_download_allowed == 1 && props.data.assFile != '') && <button
                  onClick={() => { handleDownload() }}
                  type="button"
                  class="btn btn-primary mr-2">
                  <i class="fal fa-download"></i>&nbsp; Download
                </button>}
                <button
                  onClick={props.backBtn}
                  type="button"
                  class="btn btn-primary"
                  title="Back">
                  <i class="fal fa-chevron-left"></i> Back
                </button>
              </div>

              {props.data.status !== 'Closed Not-Submitted' && props.data?.quiz_id ? <button
                onClick={() => {
                  dispatch(setAssessmentReview(true))
                  props.setStep(5)
                }}
                type="button"
                className={`btn btn-primary`}>
                <i className={"fal fa-eye"}></i>&nbsp;
                Review Submission
              </button> : null}
            </div>
            
          </div>
          <div class="test-series-main-heading mb-15">
            <h4>Details</h4>
          </div>
          <AssessmentDetailTab data={props.data} quizId={props.quizId} maxAttempt={props.maxAttempt} step={7} toolTip={props.toolTip} user={user}/>
          {props.data?.assessment_feedback_details && Object.keys(props.data.assessment_feedback_details).length > 0 &&
            (
              props.data.assessment_feedback_details.additional_feedback ||
              (props.data.assessment_feedback_details.use_generated_feedback && props.data.assessment_feedback_details.generated_feedback) ||
              props.data.assessment_feedback_details.feedback !== "" && props.data.assessment_feedback_details.feedback !== null
            ) && (
              <AssessmentDetailTab
                data={props.data}
                quizId={props.quizId}
                maxAttempt={props.maxAttempt}
                step={7}
                toolTip={props.toolTip}
                user={user}
                feedback={true}
              />
            )
          }

          <div class="test-series-main-heading mb-15">
            <h4>Result</h4>
            {(props?.data?.student_intake_status !== 3) && (props.maxAttempt > props.totalattempt) && (moment(props.data.close_date_time) >= moment()) &&
              <div>
                <span className="attempts-con">
                  Attempts left: {props.maxAttempt - props.totalattempt}
                </span>
                <span onClick={props.reAttemptQuiz} className={`retry-txt`}>
                  Retry
                </span>
              </div>
            }
          </div>
          {props?.data?.ass_type=="Survey" || (props?.data?.studentCourses && props?.data?.studentCourses.length == 1  && props?.data?.studentCourses[0]?.grading_type == "4") ? <>
          <div class="innerblue-textseries-content blue-bg-blk">
              <div class="row">
                <div class="col-md-8">
                  <div class="assessment-result-content">
                    <div className="assessment-result-st-blk">
                      <p>
                        <strong>Dear {user.fullname}</strong>
                      </p>
                      <p>Thank you for submission.</p>                       
                    </div>
                  </div>
                </div>                
              </div>
            </div>
          </>
          :
          <>
              {props.gradingStandard == 2
                ? <>
                  {
                    !(props?.data?.grademixCulc?.length > 0 && props?.data?.grademixCulc[0].gradeText == 'witheld') &&
                    <>
                      <div class="innerblue-textseries-content blue-bg-blk">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="assessment-result-content">
                              {props.data.status == "Closed-Marked" && props.data.grade == 1 ?
                                <div class="assessment-result-status">
                                  <ShowResult data={props.data} />
                                </div>
                                : null}
                              <div className="assessment-result-st-blk">
                                <p>
                                  <h4>Your Results</h4>
                                  <strong>{user.fullname}</strong>
                                </p>
                                {(props.data.status && (props.data.status.toLowerCase() == "closed not-submitted")) ? <p>You did not submit the assessment</p> :
                                  (props.data.status && (props.data.status.toLowerCase() == "closed-submitted")) ? <p>Result pending</p> : <p></p>
                                }
                                <AppealButton onClick={props.openAppealCall} appeal_button={props.data.appeal_button} row_id={props.data.id} />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-8">
                            <div class="percent-block multiple-circle">
                              {props?.data?.grade === 0 ? <div class="percent">
                                {(props?.data?.grademixCulc || []).map(item => {
                                  return (<div class="chart-canvas m-2">
                                    <CircularProgressbar
                                      styles={buildStyles(item.grade >= 75 ? styles.progressSuccess : styles.progressFail)}
                                      value={item.ass_percentage}
                                    />
                                    {item?.grading_type == 1 ? (
                                      <div className="chart-count grade_robot_text">
                                        {item.gradeText}
                                      </div>
                                    ) : (item?.grading_type == 3 ?
                                      <div className="chart-count">
                                        {`${item.gradeText}/${item.ass_total_mark}`}
                                      </div>
                                      :
                                      <div className="chart-count">
                                        {item.gradeText}
                                      </div>
                                    )}
                                    <div className="text-center mt-2">{item.sor_name}</div>
                                  </div>)
                                })}
                              </div>
                                : props.data.grade === 1
                                  ? <ShowResultPercent data={props.data} />
                                  : props.data.grade === 3
                                    ? `${props?.data?.assCalculateGradeStatus?.gradeText != null ? props?.data?.assCalculateGradeStatus?.gradeText : 0} / ${props?.data?.subAssTotMark != null ? props?.data?.subAssTotMark : 0}`
                                    : props?.data?.assCalculateGradeStatus?.gradeText
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </>}
                    </>
                    :<>
            {((props?.data?.studentCourses?.length > 0 && props?.data?.studentCourses[0].gradeText == 'witheld') || props?.data?.assCalculateGradeStatus?.gradeText =='witheld') && 
              <div className="result-ticket">
                <div className="result-ticket-inner d-flex justify-content-between">

                <div className="result-ticket-L">
                  <h5>Result have been withheld</h5>
                  <p>Your marks are being withheld due to outstanding balances on your account, you will have limited access to the portal. Please contact the finance department by logging a ticket below.</p>
                </div>

                <div className="result-ticket-R">
                  <b>Your Result: WITHHELD</b>
                </div>
                </div>

              <Link to="/addnewticket" className="btn-white-bordered-ticket"><i class="far fa-ticket-alt"></i> Log A Ticket</Link>
            </div>}
            
            {/* removed the grademix  */}
           
            {!(props?.data?.studentCourses?.length > 0 && props?.data?.studentCourses[0]?.gradeText === 'witheld') && (!!(props?.data?.studentCourses || []).filter(d => d.grading_type != "4")?.length) && (
              <>
                <div class="innerblue-textseries-content blue-bg-blk">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="assessment-result-content">
                        <div className="assessment-result-st-blk">
                          <p>
                            <h4>Your Results</h4>
                            <strong>{user.fullname}</strong>
                          </p>
                          {props.data.status &&
                            props.data.status.toLowerCase() == "closed not-submitted" ? (
                            <p>You did not submit the assessment</p>
                          ) : props.data.status &&
                            props.data.status.toLowerCase() == "closed-submitted" ? (
                            <p>Result pending</p>
                          ) : (
                            <p></p>
                          )}
                          <AppealButton
                            onClick={props.openAppealCall}
                            appeal_button={props.data.appeal_button}
                            row_id={props.data.id}
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-md-8">
                      <div class="percent-block multiple-circle">
                          <div class="percent">
                            {(props?.data?.studentCourses || []).filter(d => d.grading_type != "4").map((item) => {
                              return (
                                <div class="chart-canvas m-2">
                                  <CircularProgressbar
                                    styles={buildStyles(
                                      item?.grade >= 75
                                        ? styles.progressSuccess
                                        : styles.progressFail
                                    )}
                                    value={item?.ass_percentage}
                                  />
                                  {item?.grading_type == 1 ? (
                                    <div className="chart-count grade_robot_text">
                                      {item?.gradeText}
                                    </div>
                                  ) : item?.grading_type == 3 ? (
                                    <div className="chart-count grade_robot_text grading-type3">
                                      {`${parseFloat(parseFloat(item?.gradeText).toFixed(2))}/`} <br></br> {`${item?.ass_total_mark}`}
                                    </div>
                                  ) : item?.grading_type != 4 && (
                                    <div className="chart-count">{item?.gradeText}</div>
                                  )}
                                  <div className="text-center mt-2">
                                    {item?.courseName}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>}
</>}

        </div>
      </div>
    </>
  );
}
export default Step7;


const styles = {
  progress: {
    pathColor: `white`,
    trailColor: `rgba(255,255,255,0.5)`,
  },
  progressFail: {
    pathColor: `white`,
    trailColor: `rgba(255,255,255,0.5)`,
  },
  progressSuccess: {
    pathColor: `white`,
    trailColor: 'rgba(255,255,255,0.5)',
  }

}